import { render, staticRenderFns } from "./columnCharts.vue?vue&type=template&id=0b81838c"
import script from "./columnCharts.vue?vue&type=script&lang=js"
export * from "./columnCharts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports